<div class="card">
  <div class="card-body">
    <strong>{{ data.id }}</strong> - <strong>{{ data.name }}</strong>
    <span *ngIf="data.extra.fr">
      &nbsp;- {{ data.extra.fr.ftgpostadr5 }}, {{ data.extra.fr.ftglevpostnr }} {{ data.extra.fr.ftgpostlevadr3 }} -
      {{ data.extra.fr.comnr }}
    </span>
    <div class="btn-group float-right">
      <a class="btn btn-secondary" routerLink="/customers/{{ data.id }}" translate>MORE_INFO</a>
      <button class="btn btn-primary" (click)="selectCustomerService.selectCustomer(data.id)" translate>
        SELECT_CUSTOMER
      </button>
    </div>
  </div>
</div>
